const theme = {
  colors: {
    upliftBlack: '#000000',
    upliftWhite: '#fff',
    upliftGrey: '#ced4da',
    upgradeGreen: '#0E680E',
    upgradeActiveButton: '#0a3f07',
    headerGrey: '#586272',
    backgroundGrey: '#dde1ea',
  },
  font: {
    fontFamily: {
      default: '"Open Sans", sans-serif, Helvetica, Arial',
      rubik: 'Rubik, "Open Sans", sans-serif, Helvetica, Arial',
      flexpay: 'Graphik',
      newsCycle: 'News Cycle',
    },
  },
  minWidth: {
    atto: '321px',
    femto: '404px',
    pico: '481px',
    nano: '641px',
    micro: '768px',
    milli: '796px',
    kilo: '961px',
    mega: '992px',
    giga: '1025px',
    tera: '1281px',
  },
};

export default theme;
